abstract class UrlBuilder {

  protected static getBaseUrl (): string {
    return "";
  }

  public static build (urlTemplate: string, parameter?: { [key: string]: string }) {
    let apiUrl = this.getBaseUrl() + urlTemplate;

    if (parameter) {
      apiUrl = UrlBuilder.replaceParameterInUrl(apiUrl, parameter);
    }

    return new URL(apiUrl).toString();
  }

  private static replaceParameterInUrl (urlTemplate: string, parameter: { [key: string]: string } ): string {
    let url = urlTemplate;

    for (const prop in parameter) {
      url = url.replace(new RegExp('{' + prop + '}', 'g'), parameter[prop].trim() );
    }

    return url;
  }

}

export class ApiUrlBuilder extends UrlBuilder {
  protected static getBaseUrl (): string {
    if (!process.env.VUE_APP_API_URL) {
      throw new Error('VUE_APP_API_URL is not defined');
    }

    return process.env.VUE_APP_API_URL;
  }
}
